module.exports = __webpack_public_path__ + "media/images/global/icons/pc-bf5902a7106f0d692c4826d3b99c363c.svg";